import React, { useEffect } from 'react';
import logoutStyles from './logout.scss';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';
import sessionService from '../../services/session.service';
import LogoutAnimation from './logoutAnimation';
import { useAuth0 } from '@auth0/auth0-react';
import { Spinner } from 'shamrock-clover-ui';
import { featureService } from '../../services/feature.service';
import { useTranslation } from 'react-i18next';

const Config = require('Config');

const V2LogoutLanding = () => {
  const { isLoading, getAccessTokenSilently, logout } = useAuth0();
  const email = LocalAuth.getUser().email as string;
  const { t } = useTranslation();

  const determineLogout = async () => {
    try {
      const token = await getAccessTokenSilently();
      const features = await featureService.getFeatures(email);
      const removeDeviceIdDoc = features.includes('CPUA-5206');
      await sessionService.logout(token, removeDeviceIdDoc);
    } finally {
      localStorage.clear();
      await logout({ logoutParams: { returnTo: Config.rtsproHomepage } });
    }
  };
  useEffect(() => {
    if (!isLoading) {
      determineLogout();
    }
  }, [isLoading]);

  return (
    <div className={logoutStyles.container}>
      <LogoutAnimation />
      <p className={logoutStyles.title}>{t('logout.logging_you_out_of_rts_pro')}</p>
      <p className={logoutStyles.body}>{t('logout.this_can_take_a_few_seconds')}</p>
      <Spinner />
    </div>
  );
};
export default V2LogoutLanding;
